<template>
<main id="business-default" v-if="!notFound">
  <vue-headful
    :title="surrounding.name && item.text ? surrounding.name + ' | ' + item.text : 'Loading Page..'"
    :description="surrounding.description"
    :image="item.graphic.data.graphic"
  />
  <section
    :style="{ backgroundImage: 'url(' + item.graphic.data.graphic + ')' }"
    class="bubanner d-flex justify-content-center"
  />
  <component
    v-if="item"
    :is="componentName"
    :key="item.id"
    :item="item"
    :surrounding="surrounding"
  />
</main>
<main id="not-found" v-else>
  <p class="text-center py-4"><i>Geen pagina gevonden.</i></p>
</main>
</template>

<script>
import { mapState } from 'vuex'
import Service from '@/services/ApiService'
import _ from 'lodash'

import ecBusinessBlocks from '@/components/Business/components/Blocks'
import ecBusinessContact from '@/components/Business/components/Contact'
import ecBusinessGallery from '@/components/Business/components/Gallery'
import ecBusinessTextual from '@/components/Business/components/Textual'
import ecBusinessPdf from '@/components/Business/components/Pdf'
import ecBusinessQuestionnaire from '@/components/Business/components/Questionnaire'
import ecBusinessWebshop from '@/components/Business/components/Webshop'
import ecBusinessVideo from '@/components/Business/components/Video'
import ecBusinessDates from '@/components/Business/components/Dates'
import ecBusinessRecras from '@/components/Business/components/Recras'

export default {
  name: 'ec-business-default',
  components: {
    ecBusinessBlocks,
    ecBusinessContact,
    ecBusinessGallery,
    ecBusinessTextual,
    ecBusinessWebshop,
    ecBusinessQuestionnaire,
    ecBusinessVideo,
    ecBusinessPdf,
    ecBusinessDates,
    ecBusinessRecras
  },
  props: {
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    componentName () {
      if (this.item.type === 'enjoj\\feed\\SlideshowItem') {
        return 'ec-business-gallery'
      } else if (this.item.type === 'enjoj\\feed\\PdfItem') {
        return 'ec-business-pdf'
      } else if (this.item.type === 'enjoj\\questionnaire\\Questionnaire') {
        return 'ec-business-questionnaire'
      } else if (this.item.type === 'enjoj\\webshop\\Webshop') {
        return 'ec-business-webshop'
      } else if (this.item.type === 'enjoj\\feed\\VideoItem') {
        return 'ec-business-video'
      } else if (this.item.type === 'enjoj\\dates\\DateItem') {
        return 'ec-business-dates'
      } else if (this.item.type === 'enjoj\\dates\\Recras') {
        return 'ec-business-recras'
      } else if (this.item.children !== undefined) {
        return 'ec-business-blocks'
      } else {
        return 'ec-business-textual'
      }
    },
    id () {
      const slugs = this.$route.params.slug.split('-')
      return slugs[slugs.length - 1]
    }
  },
  data () {
    return {
      item: null,
      items: null,
      buttons: null,
      notFound: true
    }
  },
  methods: {
    setItems () {
      const includeModules = [
        'enjoj\\feed\\SlideshowItem',
        'enjoj\\feed\\UrlItem',
        'enjoj\\feed\\VideoItem',
        'enjoj\\feed\\Menu',
        'enjoj\\feed\\TextualItem',
        'enjoj\\webshop\\Webshop',
        'enjoj\\questionnaire\\Questionnaire',
        'enjoj\\feed\\PdfItem',
        'enjoj\\dates\\DateItem',
        'enjoj\\dates\\Recras'
      ]

      // Place recras 'Natuurpoort van loon'
      if (this.id === 1053) {
        this.buttons.push({
          text: 'Boeken',
          type: 'enjoj\\dates\\Recras',
          is_menu: false,
          graphic: {
            data: {
              graphic: 'https://enjoj-cdn-fra.s3.eu-central-1.amazonaws.com/Core/1564143650079r4TCHAxHLaPP4'
            }
          },
          visibility: 'web'
        })
      }

      let items = []
      this.buttons.forEach(item => {
        if (item.visibility !== 'app' && includeModules.includes(item.type)) {
          items.push(item)
        }
      })
      this.items = items
      this.setItem()
      this.$store.commit('setBusinessLoading', false)
    },
    setItem () {
      const tests = this.$route.params.pathMatch.split('/')

      let that = this
      let check = 0
      checkNext(this.items)
      function checkNext (items) {
        items.forEach(item => {
          const test = tests
          if (_.kebabCase(item.text) === test[check]) {
            if (item.is_menu) {
              check++
              if (check !== tests.length) {
                checkNext(item.children.data)
                return
              }
              that.notFound = false
              that.item = item
            } else {
              if (check + 1 === tests.length) {
                that.notFound = false
                that.item = item
              }
            }
          }
        })
      }
    }
  },
  created () {
    this.$store.commit('setBusinessLoading', true)

    const buttonUrl = 'community/surrounding/' + this.id + '/button/personal'
    Service.get(buttonUrl).then(data => {
      this.buttons = data.data[0].items.data
      this.setItems()
    })
  },
  watch: {
    '$route' () {
      this.setItem()
    }
  }
}
</script>

<style lang="scss">
ul {
  margin: 0 !important;
}
</style>